import { Div, HeaderBack, ImageView, Label } from 'components';
import { Ecolors } from 'constant';
import React from 'react';
import { useAppSelector } from 'store/hooks';
import { convertchangeIdNoStatus } from './api';
import { useRoute } from '@react-navigation/core';
import I18n from 'languages/i18n';

const ChangeCMNDtoCCCDDetailsScreen = () => {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const route = useRoute<any>();

  const {
    changeIdNoStatus,
    changeIdNoNoteReject,
    changeBankInfoStatus,
    changeBankInfoNoteReject,
    changeAddressInfoStatus,
    changeAddressInfoNoteReject,
  } = currentUser;

  const getChangeStatus = (): {
    status: 'PENDING' | 'REJECT';
    content: string;
  } => {
    switch (route.params?.change) {
      case 'bank':
        const isPendingBank = changeBankInfoStatus === 'PENDING';
        return {
          status: changeBankInfoStatus,
          content: isPendingBank
            ? I18n.t('changecmnd.PENDING_note')
            : changeBankInfoNoteReject === 'undefined'
            ? ''
            : changeBankInfoNoteReject,
        };
      case 'cccd':
        const isPendingCCCD = changeIdNoStatus === 'PENDING';
        return {
          status: changeIdNoStatus,
          content: isPendingCCCD
            ? I18n.t('changecmnd.PENDING_note')
            : changeIdNoNoteReject === 'undefined'
            ? ''
            : changeIdNoNoteReject,
        };
      case 'address':
        const isPendingAddress = changeAddressInfoStatus === 'PENDING';
        return {
          status: changeAddressInfoStatus,
          content: isPendingAddress
            ? I18n.t('changecmnd.PENDING_note')
            : changeAddressInfoNoteReject === 'undefined'
            ? ''
            : changeAddressInfoNoteReject,
        };
      default:
        return {
          status: 'PENDING',
          content: I18n.t('changecmnd.PENDING_note'),
        };
    }
  };

  const objConvert = convertchangeIdNoStatus(getChangeStatus().status);
  return (
    <Div flex={1} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack type={2} title="changecmnd.trangthaihoso" />
      <Div flex={1} paddingHorizontal={30} alignItems="center" paddingTop={43}>
        <ImageView
          widthHeight={105}
          source={objConvert.icon}
          resizeMode="contain"
        />
        <Label
          multilanguage={false}
          size={18}
          fontWeight="bold"
          marginTop={20}
          color={objConvert.color}
        >
          {objConvert.title}
        </Label>
        {getChangeStatus().status == 'REJECT' && (
          <Label marginTop={10} fontWeight="bold">
            {'changecmnd.lydotuchoi'}
          </Label>
        )}
        <Label textAlign={'center'} multilanguage={false} marginTop={20}>
          {getChangeStatus().content}
        </Label>
      </Div>
    </Div>
  );
};

export default React.memo(ChangeCMNDtoCCCDDetailsScreen);
